export default __webpack_public_path__ + "static/media/icons-16.1645f50f.woff";